import './SearchBar.scss';

import { useState } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { setSearch } from "../../slices/filterSlice";
import { setTempSearch } from "../../slices/filterSlice";
import { clearSearch } from "../../slices/filterSlice";

import { Cancel } from "@mui/icons-material";
import Search from "@mui/icons-material/Search";

import { IconButton } from "../Buttons/Buttons";

export const SearchBar = ({ componentId }) => {
    const dispatch = useDispatch();

    const search = useSelector(state =>
        state.filters.filters[componentId]?.tempSearch || ""
    );

    const [searchQuery, setSearchQuery] = useState(search);

    const handleInputChange = (e) => {
        const val = e.target.value;
        setSearchQuery(val);
        dispatch(setTempSearch({ componentId, value: val }));
    };

    const handleSearch = () => {
        dispatch(setSearch({ componentId, value: searchQuery }));
    };

    const handleClear = () => {
        dispatch(clearSearch({ componentId }));
        setSearchQuery("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    }

    return (
        <div className="search-bar">
            <div className="search-bar_wrapper">
                <input
                    className="search-bar_input"
                    value={searchQuery}
                    type="text"
                    onChange={handleInputChange}
                    placeholder="Поиск"
                    onKeyDown={handleKeyDown}
                />
                {searchQuery && (
                    <div className="search-bar_clear" onClick={handleClear}>
                        <Cancel style={{ fontSize: "18px" }} />
                    </div>
                )}
            </div>
            <IconButton Icon={Search} color="#3C50E0" onClick={handleSearch} />
        </div>
    );
}